// JCG-3532: 팝업과 메일이 공유하는 점검 일정. 이 설정은 서비스를 동결하지 않는다.
// 점검 연장 안내는 별도 공지 ID로 기존 오늘 숨기기와 구분한다.
export const MAINTENANCE_NOTICE = {
  id: "maintenance-2026-09-12-extended-0600",
  announceAt: "2026-09-10T09:00:00+09:00",
  startsAt: "2026-09-12T00:00:00+09:00",
  endsAt: "2026-09-12T06:00:00+09:00",
  title: "서버 점검 및 업데이트 시간 연장 안내",
  dateLabel: "2026년 9월 12일 (토)",
  timeLabel: "00:00–06:00 (한국시간)",
  subject: "[정처기 감자] 9월 12일 00:00–06:00 서버 점검 및 업데이트 시간 연장 안내",
  description: "서버 점검 및 업데이트 종료 예정 시간이 오전 6시로 변경되었습니다. 그때까지 학습 기록 저장과 북마크·오답노트 변경이 잠시 제한됩니다. 글·문제·해설은 계속 볼 수 있습니다.",
} as const;

export interface MaintenanceNoticeStatus {
  phase: "hidden" | "upcoming" | "ongoing";
  dayKey: string;
}

/** 서버 시각을 사용하며, 실제 저장이 재개되면 진행 중인 제한 안내를 숨긴다. */
export function getMaintenanceNoticeStatus(
  nowMs: number,
  writesFrozen = true,
): MaintenanceNoticeStatus {
  const dayKey = new Date(nowMs + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
  if (
    nowMs < Date.parse(MAINTENANCE_NOTICE.announceAt) ||
    nowMs >= Date.parse(MAINTENANCE_NOTICE.endsAt) ||
    (nowMs >= Date.parse(MAINTENANCE_NOTICE.startsAt) && !writesFrozen)
  ) {
    return { phase: "hidden", dayKey };
  }
  return {
    phase: nowMs < Date.parse(MAINTENANCE_NOTICE.startsAt) ? "upcoming" : "ongoing",
    dayKey,
  };
}
